import React, { ReactElement, useMemo } from 'react';
import { ApolloProvider } from '@apollo/client';
import type { ApolloProviderProps } from '@apollo/client/react/context';
import { useAuthenticatedFetch, useLogger } from '@e2m-customer-portal/hooks';
import { createApolloClient } from './apollo-client';

export type GraphqlClientProviderProps = Omit<ApolloProviderProps<unknown>, 'client'>;

export function GraphqlClientProvider(props: GraphqlClientProviderProps): ReactElement {
  const logger = useLogger();
  const fetch = useAuthenticatedFetch();
  const client = useMemo(() => createApolloClient(fetch, logger), [fetch, logger]);

  return <ApolloProvider client={client} {...props} />;
}
